var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sr-link-list-group"},[_c('SrHeadline',[_vm._v(" "+_vm._s(_vm.group.title)+" ")]),_vm._l((_vm.group.items),function(item,index){return _c('SrLinkListItem',_vm._b({key:index},'SrLinkListItem',item,false))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }